<template>
  <div>
    <PlanSuccessModal @next="continueToHome" v-if="showPlanSuccessModal" />

    <div v-if="routeReady">
      <div class="row" v-if="health && false">
        <div :class="$ALERT_COL">
          <Alert class="alert-attention" title="We have found potential errors on your store &rarr;" icon="IconImportant" :titleLink="healthCheck ? 'reports_health' : 'error_monitoring'"></Alert>
        </div>
      </div>
      <PasswordProtection v-if="shopObj.password_enabled" />
      <DevelopmentStore v-if="plan === 'affiliate'" />
      <ShopifyStaffStore v-if="plan === 'shopify_staff'" />

      <Heading :title="'Good ' + greeting + ', ' + shopObj.name" subTitle="Here's the status of your Superchargify installation." />

      <div class="row row-space-4 stat-primary mb-45">
        <div class="col-6 col-md-3">
          <router-link to="/amp">
            <div class="card">
              <div class="card-body">
                <h5>AMP</h5>
                <StatusCheckBox :condition="db.status.amp" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3" v-if="health && false">
          <router-link :to="{ name: healthCheck ? 'reports_health' : 'error_monitoring' }">
            <div class="card">
              <div class="card-body">
                <h5>Health</h5>
                <StatusCheckBox :condition="!health" />
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <h2 class="h5 mb-3" v-if="false">AMP Statistics</h2>

      <div class="row-space-4 mb-45" v-if="false">
        <Pageviews class="mb-3" />
        <AMPEvents />
        <p class="small text-muted mt-2 mb-0">Data may take up to 1 hour to update.</p>
      </div>
      <div class="row row-space-4 stat-secondary mb-45" v-if="false">
        <div class="col-6 col-md-3">
          <router-link :to="{ name: 'amp_products' }">
            <div class="card">
              <div class="card-body">
                <h6>Products</h6>
                <StatusCheckBox :condition="true" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link :to="{ name: 'amp_collections' }">
            <div class="card">
              <div class="card-body">
                <h6>Collections</h6>
                <StatusCheckBox :condition="vFeatures.collections" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link :to="{ name: 'amp_blog_posts' }">
            <div class="card">
              <div class="card-body">
                <h6>Blog posts</h6>
                <StatusCheckBox :condition="vFeatures.articles" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link :to="{ name: 'amp_settings' }">
            <div class="card">
              <div class="card-body">
                <h6>Reviews</h6>
                <StatusCheckBox :condition="!!settings.review" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link :to="{ name: 'amp_general' }">
            <div class="card">
              <div class="card-body">
                <h6>Logo</h6>
                <StatusCheckBox :condition="!!settings.language.logo_asset_version" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link :to="{ name: 'amp_general' }">
            <div class="card">
              <div class="card-body">
                <h6>Announcement</h6>
                <StatusCheckBox :condition="vFeatures.announcement && !!settings.layout.announcement" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link :to="{ name: 'amp_settings' }">
            <div class="card">
              <div class="card-body">
                <h6>Sitemap</h6>
                <StatusCheckBox :condition="vFeatures.sitemap" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link :to="{ name: 'amp_settings' }">
            <div class="card">
              <div class="card-body">
                <h6>Social Accounts</h6>
                <StatusCheckBox :condition="socialCheck" />
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link :to="{ name: 'amp_settings' }">
            <div class="card">
              <div class="card-body">
                <h6>Custom CSS</h6>
                <StatusCheckBox :condition="vFeatures.customcss" />
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <LeaveReview class="mt-45" alert v-if="false" />
    </div>
    <Loading v-else />
  </div>
</template>

<script>
import { get } from 'lodash-es'
import { mapState, mapActions } from 'vuex'

import StatusCheckBox from '@/components/StatusCheckBox'
import PlanSuccessModal from '@/components/PlanSuccessModal'
import DevelopmentStore from '@/components/DevelopmentStore'
import ShopifyStaffStore from '@/components/ShopifyStaffStore'
import PasswordProtection from '@/components/PasswordProtection'
import LeaveReview from '@/components/LeaveReview'
import Pageviews from '@/components/Pageviews'
import AMPEvents from '@/components/AMPEvents'

import routeReady from '@/mixins/routeReady'
import filters from '@/mixins/filters'

export default {
  components: {
    StatusCheckBox,
    PlanSuccessModal,
    DevelopmentStore,
    ShopifyStaffStore,
    PasswordProtection,
    LeaveReview,
    Pageviews,
    AMPEvents
  },
  data: function () {
    return {
      currentHour: (new Date()).getHours(),
      showPlanSuccessModal: false
    }
  },
  mixins: [ routeReady, filters ],
  computed: {
    ...mapState([ 'db', 'shopObj', 'amptheme', 'settings', 'vFeatures', 'plan', 'vAuto' ]),
    jsReqCount: function () {
      if (!this.vAuto) return 0

      return (this.vAuto.tests && this.vAuto.tests.script && this.vAuto.tests.script.length) || 0
    },
    cssReqCount: function () {
      if (!this.vAuto) return 0

      return (this.vAuto.tests && this.vAuto.tests.stylesheet && this.vAuto.tests.stylesheet.length) || 0
    },
    reqCount: function () {
      if (!this.vAuto) return 0

      return this.jsReqCount + this.cssReqCount
    },
    greeting: function () {
      const AFTERNOON = 12
      const EVENING = 17

      if (this.currentHour >= AFTERNOON && this.currentHour <= EVENING) {
        return 'afternoon'
      } else if (this.currentHour >= EVENING) {
        return 'evening'
      } else {
        return 'morning'
      }
    },
    socialCheck: function () {
      const keys = Object.keys(this.settings.social)

      for (var i = 0; i < keys.length; i++) {
        if (this.settings.social[keys[i]]) return true
      }

      return false
    },
    healthCheck: function () {
      return this.vAuto.amp || this.shopObj.password_enabled
    },
    errorMonitoring: function () {
      const errors = get(this.vAuto, 'tests.errors') || []
      return errors.length > 0
    },
    health: function () {
      return this.healthCheck || this.errorMonitoring
    }
  },
  mounted: function () {
    this.checkSubscription()
    this.interval = setInterval(() => {
      this.currentHour = (new Date()).getHours()
    }, 1000 * 60)
    this.getEvents()
  },
  beforeDestroy: function () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    ...mapActions(['getEvents']),
    continueToHome: function () {
      this.showPlanSuccessModal = false
      this.$router.replace({ name: 'home' })
    },
    checkSubscription: function () {
      if (this.$route.query.subscription === 'success') {
        this.showPlanSuccessModal = true
      } else if (this.$route.query.subscription === 'failed') {
      }
    }
  }
}
</script>
